import { axiosInstance } from '../Config/axios';

const API_URL = '/password-reset/';

// Función para recuperar contraseña
export const recoveryPassword = async (username) => {
  try {
    const response = await axiosInstance.post(API_URL, { username });
    return { response: response.data, error: null };
  } catch (error) {
    console.error('Error al recuperar contraseña:', error);
    return { response: null, error: error.response?.data || error };
  }
};

// Función para confirmar el reset de contraseña
export const confirmPassword = async ({ uid, token, new_password, confirm_password }) => {
  try {
    const response = await axiosInstance.post(
      `/password-reset/confirm/${uid}/${token}/`,
      { new_password, confirm_password }
    );
    return { response: response.data, error: null };
  } catch (error) {
    console.error('Error al guardar contraseña:', error);
    return { response: null, error: error.response?.data || error };
  }
};

// Función para recuperar contraseña desde el panel
export const adminPasswordReset = async (email) => {
  try {
    const response = await axiosInstance.post(`/admin-password-reset/`, { email });
    return { response: response.data, error: null };
  } catch (error) {
    console.error('Error al recuperar contraseña desde el panel:', error);
    return { response: null, error: error.response?.data || error };
  }
};